/*
 * @Descripttion: 数据详情
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import React, {useContext, useState} from 'react';
import {Button} from '@alifd/next';
import moment from 'moment';
import LzMsg from '@/components/common/LzMsg';
import { Servlets } from '@/service';
import utils from '@/common/utils';
import {ActivityContext} from '../../index';

const TimeInfo = () => {
  const {updateTime, taskInstId} = useContext(ActivityContext);

  const [btnLoading, setBtnLoading] = useState(false);

  const getOut = () => {
    setBtnLoading(true);
    Servlets('getEffectDataExcelout', {taskInstId}).then((res) => {
      if (res.success) {
        utils.downloadFile(res);
        setBtnLoading(false);
      } else {
        LzMsg.error(res.resp_msg);
        setBtnLoading(false);
      }
    });
  }
  return (
    <div>
      <div>
        <span>本短信任务数据最新：<span style={{color: '#3399ff'}}>更新时间：{moment(updateTime).format('YYYY-MM-DD HH:mm:ss')}</span></span>
        <Button loading={btnLoading} type='primary' style={{marginLeft: 10}} onClick={getOut}>数据导出</Button>
      </div>
    </div>
  )
};

export default TimeInfo;
